/**
 * OWNER: W0 (orchestrator; change request CR-W2-05-5, option B). The STABLE SURFACE of the Wave-1 command internals
 * that the batch tools and templates (`src/core/tools/**`, W2-05 / W2-11) build on: track read/commit (motionTrack),
 * shape-preserving splits and their reports (splitKey, motionNotes), span replacement and imported lead-ins
 * (motionTime), X/Y link alignment and link groups (link), layers, and the line / note command bodies.
 *
 * `src/core/tools/**` imports these helpers from here only. A signature or behaviour change of anything re-exported
 * here needs a change request to the packages that use it (W2-05 templates; W2-11 flatten, fit, clone, motionPath,
 * distribute, write, stagger, fill), like a contract change.
 */

export { deleteLayerBody, freeLayer, MAX_UI_LAYERS } from './layers';
export { expandNamePattern, lineCommands, MAX_BATCH_LINES } from './lines';
export {
  alignXyAll,
  alignXyBeats,
  cleanLinks,
  keyAtBeat,
  linkedNeighbours,
  syncLinkGroups,
  withXyPartners,
  xyPartnerTrack,
} from './link';
export { collectSplit, notePartnerSplit, noteWorstSplit, worseSplitOn } from './motionNotes';
export type { SplitOn } from './motionNotes';
export { explicitLeadIn, replaceSpan } from './motionTime';
export type { SliceKey } from './motionTime';
export {
  commitKeys,
  createTrack,
  easeUseFor,
  enforceKeyRules,
  neutralValue,
  newRec,
  ownerInfo,
  readKeys,
  requireTrack,
  sameValue,
  tidy,
} from './motionTrack';
export type { KeyRec, MotionView, TrackInfo } from './motionTrack';
export { noteCommands } from './notes';
export { curveCtx, defaultLeadValue, easeY, EXACT_SPLIT, setBoth, valueAtBeat, worseSplit } from './splitKey';
export type { CurveCtx, SplitReport } from './splitKey';
